import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, vShow as _vShow, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "width-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "form-header"
}
const _hoisted_4 = {
  key: 1,
  class: "form-messages"
}
const _hoisted_5 = {
  key: 0,
  class: "flashmessage flash-warning"
}
const _hoisted_6 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_7 = { class: "width-wrap" }
const _hoisted_8 = { class: "form-section has-aside" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { for: "frm-registerForm_title" }
const _hoisted_11 = {
  key: 0,
  class: "form-error"
}
const _hoisted_12 = { for: "frm-registerForm_idNumber" }
const _hoisted_13 = {
  key: 0,
  class: "form-error"
}
const _hoisted_14 = {
  key: 1,
  class: "form-error"
}
const _hoisted_15 = {
  key: 2,
  class: "form-error"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "frm-registerForm_agencyEmail" }, "E-mail:", -1)
const _hoisted_17 = {
  key: 0,
  class: "form-error"
}
const _hoisted_18 = { for: "frm-registerForm_website" }
const _hoisted_19 = {
  key: 0,
  class: "form-error"
}
const _hoisted_20 = {
  key: 1,
  class: "form-error"
}
const _hoisted_21 = { for: "frm-registerForm_agencyPhone" }
const _hoisted_22 = { class: "input-with-button" }
const _hoisted_23 = {
  key: 0,
  class: "form-error"
}
const _hoisted_24 = {
  key: 1,
  class: "form-error"
}
const _hoisted_25 = ["for"]
const _hoisted_26 = { class: "input-with-button" }
const _hoisted_27 = ["id", "onUpdate:modelValue", "name"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "form-error"
}
const _hoisted_30 = {
  key: 0,
  class: "form-group"
}
const _hoisted_31 = { for: "frm-registerForm_street" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "form-error"
}
const _hoisted_34 = { for: "frm-registerForm_zip" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "form-error"
}
const _hoisted_37 = { for: "frm-registerForm_city" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "form-error"
}
const _hoisted_40 = {
  key: 0,
  class: "form-section-aside"
}
const _hoisted_41 = { class: "form-upload-photo aspect-ratio aspect-ratio-16-9" }
const _hoisted_42 = { class: "aspect-ratio-body" }
const _hoisted_43 = {
  key: 0,
  class: "photo bordered is-uploaded"
}
const _hoisted_44 = {
  key: 1,
  class: "upload-placeholder placeholder-empty"
}
const _hoisted_45 = { class: "upload-placeholder-title" }
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = {
  key: 0,
  class: "form-error"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "line-sep" }, null, -1)
const _hoisted_50 = { class: "width-wrap" }
const _hoisted_51 = { class: "form-header" }
const _hoisted_52 = { class: "form-section has-aside" }
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = { for: "frm-registerForm_firstName" }
const _hoisted_55 = {
  key: 0,
  class: "form-error"
}
const _hoisted_56 = { for: "frm-registerForm_lastName" }
const _hoisted_57 = {
  key: 0,
  class: "form-error"
}
const _hoisted_58 = { for: "frm-registerForm_email" }
const _hoisted_59 = {
  key: 0,
  class: "form-error"
}
const _hoisted_60 = {
  key: 1,
  class: "form-error"
}
const _hoisted_61 = { for: "frm-registerForm_confirmEmail" }
const _hoisted_62 = { class: "help" }
const _hoisted_63 = {
  key: 0,
  class: "form-error"
}
const _hoisted_64 = {
  key: 1,
  class: "form-error"
}
const _hoisted_65 = { for: "frm-registerForm_password" }
const _hoisted_66 = { class: "help" }
const _hoisted_67 = {
  key: 0,
  class: "form-error"
}
const _hoisted_68 = {
  key: 1,
  class: "form-error"
}
const _hoisted_69 = { for: "frm-registerForm_confirmPassword" }
const _hoisted_70 = { class: "help" }
const _hoisted_71 = {
  key: 0,
  class: "form-error"
}
const _hoisted_72 = {
  key: 1,
  class: "form-error"
}
const _hoisted_73 = { for: "frm-registerForm_phoneNumber" }
const _hoisted_74 = { class: "multiple-inputs" }
const _hoisted_75 = { class: "selectbox selectbox--phone-prefix" }
const _hoisted_76 = {
  key: 0,
  class: "form-error"
}
const _hoisted_77 = {
  key: 0,
  class: "form-error"
}
const _hoisted_78 = {
  key: 1,
  class: "form-error"
}
const _hoisted_79 = {
  key: 0,
  class: "form-section-aside"
}
const _hoisted_80 = { class: "form-upload-photo aspect-ratio aspect-ratio-1-1" }
const _hoisted_81 = { class: "aspect-ratio-body" }
const _hoisted_82 = {
  key: 0,
  class: "photo is-uploaded"
}
const _hoisted_83 = {
  key: 1,
  class: "upload-placeholder placeholder-user"
}
const _hoisted_84 = ["innerHTML"]
const _hoisted_85 = {
  key: 0,
  class: "form-error"
}
const _hoisted_86 = { key: 0 }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "line-sep" }, null, -1)
const _hoisted_88 = { class: "width-wrap" }
const _hoisted_89 = { class: "form-heading" }
const _hoisted_90 = { class: "form-field" }
const _hoisted_91 = { class: "checkbox" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_93 = { class: "form-group" }
const _hoisted_94 = { for: "frm-registerForm_invoiceStreet" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = {
  key: 0,
  class: "form-error"
}
const _hoisted_97 = { for: "frm-registerForm_invoiceZip" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = {
  key: 0,
  class: "form-error"
}
const _hoisted_100 = { for: "frm-registerForm_invoiceCity" }
const _hoisted_101 = ["disabled"]
const _hoisted_102 = {
  key: 0,
  class: "form-error"
}
const _hoisted_103 = { class: "form-group" }
const _hoisted_104 = { for: "frm-registerForm_vatIdNumber" }
const _hoisted_105 = {
  key: 0,
  class: "form-error"
}
const _hoisted_106 = {
  key: 1,
  class: "form-error"
}
const _hoisted_107 = { for: "frm-registerForm_taxIdNumber" }
const _hoisted_108 = {
  key: 0,
  class: "form-error"
}
const _hoisted_109 = {
  key: 1,
  class: "form-error"
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "line-sep" }, null, -1)
const _hoisted_111 = { class: "width-wrap" }
const _hoisted_112 = { class: "form-heading" }
const _hoisted_113 = { class: "form-group" }
const _hoisted_114 = { for: "frm-registerForm_backOfficeConsumerKey" }
const _hoisted_115 = { for: "frm-registerForm_backOfficeConsumerSecret" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "line-sep" }, null, -1)
const _hoisted_117 = { class: "width-wrap" }
const _hoisted_118 = { class: "form-footer" }
const _hoisted_119 = { class: "checkbox" }
const _hoisted_120 = ["innerHTML"]
const _hoisted_121 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_122 = {
  key: 0,
  class: "form-error"
}
const _hoisted_123 = { class: "checkbox" }
const _hoisted_124 = ["innerHTML"]
const _hoisted_125 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_126 = {
  key: 0,
  class: "form-error"
}
const _hoisted_127 = { class: "checkbox" }
const _hoisted_128 = ["innerHTML"]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_130 = {
  key: 0,
  class: "form-error"
}
const _hoisted_131 = { class: "button button--primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MapPosition = _resolveComponent("MapPosition")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_PhonePrefix = _resolveComponent("PhonePrefix")!
  const _component_Cropper = _resolveComponent("Cropper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      id: "registration-professional-form",
      class: "form",
      onSubmit: _cache[37] || (_cache[37] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"])),
      autocomplete: "off"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('RegistrationAgent.form-header')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFormMessages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.isSuccess)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('RegistrationAgent.success-message')), 1))
                : _createCommentVNode("", true),
              (_ctx.isError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('RegistrationAgent.error-message')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flashmessage flash-danger"
                }, _toDisplayString(error), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isSuccess)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.title.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('RegistrationAgent.title')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.title.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_title",
                      name: "title",
                      class: "form-control is-required"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.title.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.v$.form.title.$dirty && _ctx.v$.form.title.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.title.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.idNumber.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('RegistrationAgent.idNumber')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.idNumber.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_idNumber",
                      name: "idNumber",
                      class: "form-control is-required"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.idNumber.$model,
                        void 0,
                        {
                          trim: true,
                          lazy: true
                        }
                      ]
                    ]),
                    (_ctx.v$.form.idNumber.$dirty && _ctx.v$.form.idNumber.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.idNumber.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.v$.form.idNumber.required.$invalid && _ctx.v$.form.idNumber.isUnique.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                _createTextVNode(_toDisplayString(_ctx.$t('RegistrationAgent.idNumber-unique-error')) + " ", 1),
                                (_ctx.idNumberValidationData && _ctx.idNumberValidationData.urlName)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: { name: 'AdAgencyList', params: { urlName: _ctx.idNumberValidationData.urlName } }
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.idNumberValidationData.title), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.idNumber.maxLength.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('forms.max', { count: _ctx.v$.form.idNumber.maxLength.$params.max })), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.agencyEmail.$error }])
                  }, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.agencyEmail.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_agencyEmail",
                      name: "agencyEmail",
                      class: "form-control is-required",
                      autocapitalize: "off"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.agencyEmail.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.v$.form.agencyEmail.$dirty && _ctx.v$.form.agencyEmail.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.agencyEmail.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.website.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('RegistrationAgent.website')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.form.website.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_website",
                      name: "website",
                      placeholder: "https://www.stranka.sk",
                      class: "form-control",
                      autocapitalize: "off"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.website.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.v$.form.website.$dirty && _ctx.v$.form.website.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.website.required && _ctx.v$.form.website.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.website.url.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t('forms.url')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.agencyPhone.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('RegistrationAgent.agencyPhone')) + ":", 1),
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.form.agencyPhone.$model) = $event)),
                        type: "text",
                        id: "frm-registerForm_agencyPhone",
                        name: "agencyPhone",
                        placeholder: "+421 900 000 000",
                        class: "form-control is-required"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.agencyPhone.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("button", {
                        class: "clone",
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.phoneNumbers.push('')))
                      })
                    ]),
                    (_ctx.v$.form.agencyPhone.$dirty && _ctx.v$.form.agencyPhone.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.agencyPhone.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.agencyPhone.phoneNumber.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('forms.phone-number')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.phoneNumbers, (phone, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-field",
                      key: index
                    }, [
                      _createElementVNode("label", {
                        for: 'frm-registerForm_agencyPhone' + index
                      }, _toDisplayString(_ctx.$t('RegistrationAgent.agencyPhone')) + ":", 9, _hoisted_25),
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: 'frm-registerForm_agencyPhone' + index,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.form.phoneNumbers[index]) = $event),
                          name: 'agencyPhone' + index,
                          placeholder: "+421 900 000 000",
                          class: "form-control"
                        }, null, 8, _hoisted_27), [
                          [
                            _vModelText,
                            _ctx.form.phoneNumbers[index],
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("button", {
                          class: "remove",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removePhoneNumber(index))
                        }, null, 8, _hoisted_28)
                      ])
                    ]))
                  }), 128)),
                  _createVNode(_component_MapPosition, {
                    position: _ctx.initialPosition,
                    onAddressChanged: _ctx.onAddressChanged,
                    hasError: _ctx.v$.form.address.$error,
                    label: "Adresa"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.v$.form.address.$dirty && _ctx.v$.form.address.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.address.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["position", "onAddressChanged", "hasError"]),
                  (_ctx.showAddressForm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.street.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('RegistrationAgent.street')) + ":", 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.form.street.$model) = $event)),
                            type: "text",
                            disabled: !_ctx.address || _ctx.address.street || _ctx.address.streetNumber,
                            id: "frm-registerForm_street",
                            name: "street",
                            class: "form-control is-required"
                          }, null, 8, _hoisted_32), [
                            [
                              _vModelText,
                              _ctx.v$.form.street.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.form.street.$dirty && _ctx.v$.form.street.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.street.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.zip.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('RegistrationAgent.zip')) + ":", 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.form.zip.$model) = $event)),
                            type: "text",
                            disabled: !_ctx.address || _ctx.address.zip,
                            id: "frm-registerForm_zip",
                            name: "zip",
                            class: "form-control is-required"
                          }, null, 8, _hoisted_35), [
                            [
                              _vModelText,
                              _ctx.v$.form.zip.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.form.zip.$dirty && _ctx.v$.form.zip.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.zip.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.city.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('RegistrationAgent.city')) + ":", 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.form.city.$model) = $event)),
                            type: "text",
                            disabled: !_ctx.address || _ctx.address.city,
                            id: "frm-registerForm_city",
                            name: "city",
                            class: "form-control is-required"
                          }, null, 8, _hoisted_38), [
                            [
                              _vModelText,
                              _ctx.v$.form.city.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.form.city.$dirty && _ctx.v$.form.city.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.city.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.estateAgencyImage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.estateAgencyImage.isError }])
                      }, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            (_ctx.estateAgencyImage.isSuccess)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  (_ctx.estateAgencyImage.isSuccess)
                                    ? (_openBlock(), _createBlock(_component_ResizableImage, {
                                        key: 0,
                                        url: _ctx.estateAgencyImage.url,
                                        width: 320,
                                        height: 180,
                                        hrmode: "max",
                                        alt: _ctx.estateAgencyImage.file,
                                        draggable: false
                                      }, null, 8, ["url", "alt"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteEstateAgencyFile())),
                                    class: "delete-photo"
                                  }),
                                  _createElementVNode("span", {
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editEstateAgencyFile())),
                                    class: "edit-photo"
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("label", _hoisted_44, [
                                  _createElementVNode("input", {
                                    type: "file",
                                    accept: "image/png, image/jpeg",
                                    ref: "estateAgencyImage",
                                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleEstateAgencyImageUpload()))
                                  }, null, 544),
                                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('RegistrationAgent.logo-button')), 1),
                                  _createElementVNode("i", {
                                    innerHTML: _ctx.$t('RegistrationAgent.logo-button-info')
                                  }, null, 8, _hoisted_46)
                                ])),
                            (_ctx.estateAgencyImage.isUploading)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "progress-bar",
                                  style: _normalizeStyle({ width: _ctx.estateAgencyImage.uploadPercentage + '%' })
                                }, null, 4))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.estateAgencyImage.isError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.estateAgencyImage.text), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      (_ctx.estateAgencyImage.isSuccess)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                            _createTextVNode(_toDisplayString(_ctx.$t('RegistrationAgent.logo-edit1')) + " ", 1),
                            _createElementVNode("a", {
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.editEstateAgencyFile()))
                            }, _toDisplayString(_ctx.$t('RegistrationAgent.logo-edit2')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('RegistrationAgent.agent-form-header')), 1)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.firstName.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t('RegistrationAgent.firstName')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.form.firstName.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_firstName",
                      name: "firstName",
                      class: "form-control is-required"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.firstName.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.v$.form.firstName.$dirty && _ctx.v$.form.firstName.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.firstName.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.lastName.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('RegistrationAgent.lastName')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.v$.form.lastName.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_lastName",
                      name: "lastName",
                      class: "form-control is-required"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.lastName.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.v$.form.lastName.$dirty && _ctx.v$.form.lastName.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.lastName.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.email.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('RegistrationAgent.email')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_email",
                      name: "email",
                      class: "form-control is-required",
                      autocapitalize: "off"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.email.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.v$.form.email.$dirty && _ctx.v$.form.email.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.email.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.email.email.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t('forms.email')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.confirmEmail.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('RegistrationAgent.email')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.v$.form.confirmEmail.$model) = $event)),
                      onPaste: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["prevent"])),
                      type: "text",
                      id: "frm-registerForm_confirmEmail",
                      name: "confirmEmail",
                      class: "form-control is-required",
                      autocapitalize: "off"
                    }, null, 544), [
                      [
                        _vModelText,
                        _ctx.v$.form.confirmEmail.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('RegistrationAgent.email-help-confirm')), 1),
                    (_ctx.v$.form.confirmEmail.$dirty && _ctx.v$.form.confirmEmail.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.confirmEmail.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.confirmEmail.sameAsEmail.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.$t('RegistrationAgent.email-mismatch')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.password.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('RegistrationAgent.password')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.v$.form.password.$model) = $event)),
                      type: "password",
                      id: "frm-registerForm_password",
                      name: "password",
                      class: "form-control is-required"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.password.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$t('forms.min', { count: _ctx.v$.form.password.minLength.$params.min })), 1),
                    (_ctx.v$.form.password.$dirty && _ctx.v$.form.password.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.password.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.password.minLength.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.$t('forms.min', { count: _ctx.v$.form.password.minLength.$params.min })), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.confirmPassword.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('RegistrationAgent.password')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.v$.form.confirmPassword.$model) = $event)),
                      type: "password",
                      id: "frm-registerForm_confirmPassword",
                      name: "confirmPassword",
                      class: "form-control is-required"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.confirmPassword.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.$t('RegistrationAgent.password-help-confirm')), 1),
                    (_ctx.v$.form.confirmPassword.$dirty && _ctx.v$.form.confirmPassword.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.confirmPassword.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.confirmPassword.sameAsPassword.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(_ctx.$t('RegistrationAgent.password-mismatch')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.phoneNumber.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t('RegistrationAgent.phoneNumber')) + ":", 1),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createVNode(_component_PhonePrefix, {
                          id: "frm-registerForm_phoneNumberPrefix",
                          modelValue: _ctx.v$.form.phoneNumberPrefix.$model,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.v$.form.phoneNumberPrefix.$model) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.v$.form.phoneNumber.$model) = $event)),
                        type: "text",
                        id: "frm-registerForm_phoneNumber",
                        placeholder: "900 000 000",
                        name: "phoneNumber",
                        class: "form-control is-required"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.phoneNumber.$model,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    (_ctx.v$.form.phoneNumberPrefix.$dirty && _ctx.v$.form.phoneNumberPrefix.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.phoneNumberPrefix.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    ((_ctx.v$.form.phoneNumberPrefix.$dirty || _ctx.v$.form.phoneNumber.$dirty) && _ctx.v$.form.phoneNumber.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.v$.form.phoneNumber.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.phoneNumber.phoneNumber.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(_ctx.$t('forms.phone-number')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                (_ctx.estateAgentImage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.estateAgentImage.isError }])
                      }, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            (_ctx.estateAgentImage.isSuccess)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                  (_ctx.estateAgentImage.isSuccess)
                                    ? (_openBlock(), _createBlock(_component_ResizableImage, {
                                        key: 0,
                                        url: _ctx.estateAgentImage.url,
                                        width: 220,
                                        height: 220,
                                        hrmode: "max",
                                        alt: _ctx.estateAgentImage.file,
                                        draggable: false
                                      }, null, 8, ["url", "alt"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.deleteEstateAgentFile())),
                                    class: "delete-photo"
                                  }),
                                  _createElementVNode("span", {
                                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.editEstateAgentFile())),
                                    class: "edit-photo"
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("label", _hoisted_83, [
                                  _createElementVNode("input", {
                                    type: "file",
                                    accept: "image/jpeg",
                                    ref: "estateAgentImage",
                                    onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleEstateAgentImageUpload()))
                                  }, null, 544),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('RegistrationAgent.photo-button')), 1),
                                  _createElementVNode("i", {
                                    innerHTML: _ctx.$t('RegistrationAgent.photo-button-info')
                                  }, null, 8, _hoisted_84)
                                ])),
                            (_ctx.estateAgentImage.isUploading)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "progress-bar",
                                  style: _normalizeStyle({ width: _ctx.estateAgentImage.uploadPercentage + '%' })
                                }, null, 4))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.estateAgentImage.isError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(_ctx.estateAgentImage.text), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      (_ctx.estateAgentImage.isSuccess)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_86, [
                            _createTextVNode(_toDisplayString(_ctx.$t('RegistrationAgent.photo-edit1')) + " ", 1),
                            _createElementVNode("a", {
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.editEstateAgentFile()))
                            }, _toDisplayString(_ctx.$t('RegistrationAgent.photo-edit2')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_87,
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('RegistrationAgent.form-header-invoice-data')), 1)
              ]),
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("label", _hoisted_91, [
                  _createTextVNode(_toDisplayString(_ctx.$t('RegistrationAgent.invoice-address-different')) + " ", 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.isInvoiceAddressDifferent) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.isInvoiceAddressDifferent]
                  ]),
                  _hoisted_92
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_93, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.invoiceStreet.$error }])
                }, [
                  _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t('RegistrationAgent.invoice-street')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.v$.form.invoiceStreet.$model) = $event)),
                    disabled: !_ctx.form.isInvoiceAddressDifferent,
                    type: "text",
                    id: "frm-registerForm_invoiceStreet",
                    name: "invoiceStreet",
                    class: "form-control is-required"
                  }, null, 8, _hoisted_95), [
                    [
                      _vModelText,
                      _ctx.v$.form.invoiceStreet.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.invoiceStreet.$dirty && _ctx.v$.form.invoiceStreet.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.invoiceStreet.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.invoiceZip.$error }])
                }, [
                  _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.$t('RegistrationAgent.invoice-zip')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.v$.form.invoiceZip.$model) = $event)),
                    disabled: !_ctx.form.isInvoiceAddressDifferent,
                    type: "text",
                    id: "frm-registerForm_invoiceZip",
                    name: "invoiceZip",
                    class: "form-control is-required"
                  }, null, 8, _hoisted_98), [
                    [
                      _vModelText,
                      _ctx.v$.form.invoiceZip.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.invoiceZip.$dirty && _ctx.v$.form.invoiceZip.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.invoiceZip.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.invoiceCity.$error }])
                }, [
                  _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t('RegistrationAgent.invoice-city')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.v$.form.invoiceCity.$model) = $event)),
                    type: "text",
                    disabled: !_ctx.form.isInvoiceAddressDifferent,
                    id: "frm-registerForm_invoiceCity",
                    name: "invoiceCity",
                    class: "form-control is-required"
                  }, null, 8, _hoisted_101), [
                    [
                      _vModelText,
                      _ctx.v$.form.invoiceCity.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.invoiceCity.$dirty && _ctx.v$.form.invoiceCity.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.invoiceCity.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ], 512), [
                [_vShow, _ctx.form.isInvoiceAddressDifferent]
              ]),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.vatIdNumber.$error }])
                }, [
                  _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.$t('RegistrationAgent.invoice-vatidnumber')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.v$.form.vatIdNumber.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_vatIdNumber",
                    name: "vatIdNumber",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.vatIdNumber.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.vatIdNumber.$dirty && _ctx.v$.form.vatIdNumber.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.vatIdNumber.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_105, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.vatIdNumber.maxLength.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(_ctx.$t('forms.max', { count: _ctx.v$.form.vatIdNumber.maxLength.$params.max })), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.taxIdNumber.$error }])
                }, [
                  _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.$t('RegistrationAgent.invoice-taxidnumber')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.v$.form.taxIdNumber.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_taxIdNumber",
                    name: "taxIdNumber",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.taxIdNumber.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.taxIdNumber.$dirty && _ctx.v$.form.taxIdNumber.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.taxIdNumber.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.taxIdNumber.maxLength.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_109, _toDisplayString(_ctx.$t('forms.max', { count: _ctx.v$.form.taxIdNumber.maxLength.$params.max })), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]),
            _hoisted_110,
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('RegistrationAgent.form-header-backoffice')), 1)
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.backOfficeConsumerKey.$error }])
                }, [
                  _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.$t('RegistrationAgent.backOfficeConsumerKey')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.v$.form.backOfficeConsumerKey.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_backOfficeConsumerKey",
                    name: "backOfficeConsumerKey",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.backOfficeConsumerKey.$model,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.backOfficeConsumerSecret.$error }])
                }, [
                  _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('RegistrationAgent.backOfficeConsumerSecret')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.v$.form.backOfficeConsumerSecret.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_backOfficeConsumerSecret",
                    name: "backOfficeConsumerSecret",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.backOfficeConsumerSecret.$model,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ], 2)
              ])
            ]),
            _hoisted_116,
            _createElementVNode("div", _hoisted_117, [
              _createElementVNode("div", _hoisted_118, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.generalTermsAgreement.$error }])
                }, [
                  _createElementVNode("label", _hoisted_119, [
                    _createElementVNode("span", {
                      innerHTML: _ctx.$t('RegistrationAgent.general-terms', { generalTermsUrl: _ctx.generalTermsUrl, domain: _ctx.domain })
                    }, null, 8, _hoisted_120),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.v$.form.generalTermsAgreement.$model) = $event)),
                      type: "checkbox",
                      id: "frm-registerForm_generalTermsAgreement",
                      name: "generalTermsAgreement"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.v$.form.generalTermsAgreement.$model]
                    ]),
                    _hoisted_121
                  ]),
                  (_ctx.v$.form.generalTermsAgreement.$dirty && _ctx.v$.form.generalTermsAgreement.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.generalTermsAgreement.sameAs.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_122, _toDisplayString(_ctx.$t('forms.required-agreement')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.personalAgreement.$error }])
                }, [
                  _createElementVNode("label", _hoisted_123, [
                    _createElementVNode("span", {
                      innerHTML: _ctx.$t('RegistrationAgent.personal-agreement', { privacyUrl: _ctx.privacyUrl, domain: _ctx.domain })
                    }, null, 8, _hoisted_124),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.v$.form.personalAgreement.$model) = $event)),
                      type: "checkbox",
                      id: "frm-registerForm_personalAgreement",
                      name: "personalAgreement"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.v$.form.personalAgreement.$model]
                    ]),
                    _hoisted_125
                  ]),
                  (_ctx.v$.form.personalAgreement.$dirty && _ctx.v$.form.personalAgreement.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.personalAgreement.sameAs.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_126, _toDisplayString(_ctx.$t('forms.required-agreement')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                (_ctx.isCompetition)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.competitionTermsAgreement.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_127, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.$t('RegistrationAgent.competition-terms-agreement', { competitionTermsUrl: _ctx.competitionTermsUrl, domain: _ctx.domain })
                        }, null, 8, _hoisted_128),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.v$.form.competitionTermsAgreement.$model) = $event)),
                          type: "checkbox",
                          id: "frm-registerForm_competitionTermsAgreement",
                          name: "competitionTermsAgreement"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.v$.form.competitionTermsAgreement.$model]
                        ]),
                        _hoisted_129
                      ]),
                      (_ctx.v$.form.competitionTermsAgreement.$dirty && _ctx.v$.form.competitionTermsAgreement.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.competitionTermsAgreement.sameAs.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_130, _toDisplayString(_ctx.$t('forms.required-agreement')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("button", _hoisted_131, _toDisplayString(_ctx.$t('RegistrationAgent.button-register')), 1)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ], 32),
    (_ctx.showEstateAgencyImageModal)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#container"
        }, [
          _createVNode(_component_Cropper, {
            img: _ctx.estateAgencyImage.url,
            fileName: _ctx.estateAgencyImage.file,
            aspectRatio: 16 / 9,
            accept: "image/png",
            onUpload: _ctx.uploadEstateAgencyImage,
            onClose: _cache[38] || (_cache[38] = ($event: any) => (_ctx.showEstateAgencyImageModal = false))
          }, null, 8, ["img", "fileName", "onUpload"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEstateAgentImageModal)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#container"
        }, [
          _createVNode(_component_Cropper, {
            img: _ctx.estateAgentImage.url,
            fileName: _ctx.estateAgentImage.file,
            aspectRatio: 1 / 1,
            accept: "image/jpeg",
            onUpload: _ctx.uploadEstateAgentImage,
            onClose: _cache[39] || (_cache[39] = ($event: any) => (_ctx.showEstateAgentImageModal = false))
          }, null, 8, ["img", "fileName", "onUpload"])
        ]))
      : _createCommentVNode("", true)
  ]))
}